import {
  CHAT_CARD_TYPE,
  MERCHANT_EMAIL_REQUEST_CUSTOM_TYPE,
  OPEN_ITEM_CUSTOM_TYPE,
  PRICED_TICKET_CARD,
  REQUESTED_ANSWERS_CUSTOM_TYPE,
  REQUESTED_DOCUMENTS_CUSTOM_TYPE,
  REQUESTED_INFO_CUSTOM_TYPE,
  SENSITIVE_DATA_CUSTOM_TYPE,
  REQUESTED_DFT_REVIEW_TYPE,
} from "constants/chatType";
import React from "react";
import { CustomData } from "types/Models/reviewDocumentAndBalancingPayment";
import { CardTypeCTAS } from "../ActionButtons/CardTypeCTAS";
import { MessageResponse } from "stream-chat";
import { DefaultStreamChatGenerics } from "stream-chat-react";
import { SensitiveDataCTA } from "../ActionButtons/SensitiveDataCTA";
import { RequestDocumentCTA } from "../ActionButtons/RequestedDocumentCTA";
import { OpenItemCTA } from "../ActionButtons/OpenItemCTA";
import { RequestedInfoCTA } from "../ActionButtons/RequestedInfoCTA";
import { RequestAnswerCTA } from "../ActionButtons/RequestAnswerCTA";
import { Button } from "components/DesignSystem/Button/Button";
import { RequestedVendorEmailCTA } from "../ActionButtons/RequestedVendorEmailCTA";
import { ReviewDftFiling } from "../ActionButtons/ReviewDftFiling";
import { PricedTicketCTA } from "../ActionButtons/PricedTicketCTA";

export const PendingActionCardCTAS = ({
  message,
  groupId,
  completed,
}: {
  message: MessageResponse<DefaultStreamChatGenerics> & {
    custom_data: CustomData;
  };
  groupId: string;
  completed?: boolean;
}) => {
  const { custom_type, custom_data, id } = message;
  switch (custom_type) {
    case CHAT_CARD_TYPE:
      return (
        <CardTypeCTAS
          customData={custom_data}
          messageId={id}
          completed={completed}
        />
      );

    case OPEN_ITEM_CUSTOM_TYPE:
      return (
        <OpenItemCTA
          customData={custom_data as any}
          messageId={id}
          completed={completed}
          btnType="secondary"
        />
      );

    case REQUESTED_DOCUMENTS_CUSTOM_TYPE:
      return message.channel?.id ? (
        <RequestDocumentCTA
          customData={custom_data as any}
          channelId={message.channel?.id}
          groupId={groupId}
          entityId={message.channel?.entity_id as string}
          completed={completed}
        />
      ) : null;

    case SENSITIVE_DATA_CUSTOM_TYPE:
      return (
        <SensitiveDataCTA
          customData={custom_data as any}
          customText={completed ? "View" : "Add"}
        />
      );

    case REQUESTED_INFO_CUSTOM_TYPE:
      return message.channel?.id ? (
        <RequestedInfoCTA
          customData={custom_data as any}
          groupId={groupId}
          messageId={id}
          channelId={message.channel?.id}
          customText={completed ? "View" : "Add"}
        />
      ) : null;

    case REQUESTED_ANSWERS_CUSTOM_TYPE:
      return message.channel?.id ? (
        <RequestAnswerCTA customData={custom_data as any} groupId={groupId} />
      ) : null;

    case MERCHANT_EMAIL_REQUEST_CUSTOM_TYPE:
      return message.id ? (
        <RequestedVendorEmailCTA
          customData={custom_data as any}
          messageId={message.id}
        />
      ) : null;

    case REQUESTED_DFT_REVIEW_TYPE:
      return message.id ? (
        <ReviewDftFiling
          customData={custom_data}
          messageId={message.id}
          groupId={groupId}
        />
      ) : null;

    case PRICED_TICKET_CARD:
      return message.id ? (
        <PricedTicketCTA
          customData={custom_data}
          messageId={message.id}
          groupId={groupId}
        />
      ) : null;

    default:
      return null;
  }
};
